/**
 * Charge Entity Definition
 */
import { ChargeRelationSchema, PaymentRelationSchema, RefundRelationSchema } from "../schemas/relations";
import { BillingDataEntityDef } from "./billing-data.entity";
import { defineEntity, } from "./core";
import { getLazyBotConfigEntityDef, getLazyUserEntityDef } from "./lazy-refs";
import { SubscriptionEntityDef } from "./subscription.entity";
// Payment entity (used in charge.pm_payments)
export const PaymentEntityDef = defineEntity({
    name: "payment",
    schema: PaymentRelationSchema,
    relations: {},
});
// Forward declare ChargeEntityDef for the circular reference in RefundEntityDef
export const ChargeEntityDef = defineEntity({
    name: "charge",
    schema: ChargeRelationSchema,
    relations: {
        pm_subscription: { type: "one", entity: () => SubscriptionEntityDef },
        pm_payments: { type: "many", entity: () => PaymentEntityDef },
        pm_refunds: { type: "many", entity: () => RefundEntityDef },
        pm_issuerBillingData: { type: "one", entity: () => BillingDataEntityDef },
        pm_recipientBillingData: { type: "one", entity: () => BillingDataEntityDef },
        bot_config: { type: "one", entity: getLazyBotConfigEntityDef },
        pm_user: { type: "one", entity: getLazyUserEntityDef },
    },
});
// Refund entity - defined after ChargeEntityDef
export const RefundEntityDef = defineEntity({
    name: "refund",
    schema: RefundRelationSchema,
    relations: {
        pm_issuerBillingData: { type: "one", entity: () => BillingDataEntityDef },
        pm_recipientBillingData: { type: "one", entity: () => BillingDataEntityDef },
        bot_config: { type: "one", entity: getLazyBotConfigEntityDef },
        pm_user: { type: "one", entity: getLazyUserEntityDef },
        pm_charge: { type: "one", entity: () => ChargeEntityDef },
    },
});
